import { refreshPrescriptionAfterCoverageReview } from "@/core/clinical/prescription-fulfillment";
import { patchImagingExamInsurerApproval } from "@/core/imaging/imaging-store";
import type { InsurerApprovalStatus as ImagingInsurerApproval } from "@/core/imaging/types";
import { patchLabOrderInsurerApproval } from "@/core/laboratory/lab-store";
import type { InsurerApprovalStatus as LabInsurerApproval } from "@/core/laboratory/types";
import type { CoverageCase, CoverageCaseStatus } from "./types";

function mapCoverageStatusToLabApproval(
  status: CoverageCaseStatus,
): LabInsurerApproval {
  if (status === "approved") return "approved";
  if (status === "rejected") return "rejected";
  if (status === "partial") return "pending";
  return "pending";
}

function mapCoverageStatusToImagingApproval(
  status: CoverageCaseStatus,
): ImagingInsurerApproval {
  if (status === "approved") return "approved";
  if (status === "rejected") return "rejected";
  if (status === "partial") return "pending";
  return "pending";
}

/** Met à jour labo, imagerie et pharmacie après validation/refus assureur. */
export function applyCoverageCaseReviewSideEffects(coverageCase: CoverageCase): void {
  if (coverageCase.labOrderId) {
    patchLabOrderInsurerApproval(
      coverageCase.labOrderId,
      mapCoverageStatusToLabApproval(coverageCase.status),
    );
  }

  if (coverageCase.imagingExamId) {
    patchImagingExamInsurerApproval(
      coverageCase.imagingExamId,
      mapCoverageStatusToImagingApproval(coverageCase.status),
    );
  }

  if (coverageCase.prescriptionId) {
    refreshPrescriptionAfterCoverageReview(coverageCase.prescriptionId);
  }
}
